var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThematic = function SvgThematic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#D0DCD4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2494 44C36.0634 44 35.8744 43.948 35.7074 43.839L31.4574 41.089C30.9944 40.789 30.8614 40.17 31.1614 39.706C31.4614 39.243 32.0804 39.11 32.5444 39.41L36.7944 42.16C37.2574 42.46 37.3904 43.079 37.0904 43.543C36.8984 43.839 36.5774 44 36.2494 44Z",
    fill: "#455E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7505 44C27.4225 44 27.1015 43.839 26.9105 43.543C26.6105 43.079 26.7435 42.46 27.2065 42.16L31.4565 39.41C31.9205 39.109 32.5395 39.243 32.8395 39.706C33.1395 40.17 33.0065 40.789 32.5435 41.089L28.2935 43.839C28.1245 43.948 27.9365 44 27.7505 44Z",
    fill: "#455E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 39V43C31 43.552 31.448 44 32 44C32.552 44 33 43.552 33 43V39H31Z",
    fill: "#455E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75 26.5H22.25C22.079 26.5 21.914 26.475 21.75 26.449V36.25C21.75 37.215 22.535 38 23.5 38H40.5C41.465 38 42.25 37.215 42.25 36.25V26.449C42.086 26.475 41.921 26.5 41.75 26.5ZM38.022 29.635L34.204 34.278C33.881 34.671 33.314 34.759 32.887 34.482L30.694 33.059L27.447 36.217C27.253 36.406 27.001 36.5 26.75 36.5C26.489 36.5 26.229 36.399 26.033 36.197C25.648 35.801 25.657 35.168 26.053 34.783L29.871 31.069C30.204 30.743 30.719 30.692 31.113 30.947L33.227 32.318L36.478 28.365C36.829 27.939 37.46 27.878 37.886 28.228C38.312 28.579 38.373 29.208 38.022 29.635Z",
    fill: "#455E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75 25.5H22.25C21.009 25.5 20 24.491 20 23.25C20 22.009 21.009 21 22.25 21H41.75C42.991 21 44 22.009 44 23.25C44 24.491 42.991 25.5 41.75 25.5Z",
    fill: "#455E4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThematic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thematic.4a1755de.svg";
export { ForwardRef as ReactComponent };